import type { TFunction } from 'i18next';
import type { FeedbackApi } from '../../utils/feedback';
import { deleteCustomer } from './api/customersApi';

export type CustomerDeleteOutcome = 'deleted' | 'archived' | 'failed';

const BRANCHES_BLOCK_MESSAGES = [
  'Customer with active branches cannot be deleted',
  'Customer with branches cannot be deleted'
];

/**
 * Delete one customer from the list row menu or the card's „Więcej” menu.
 * The backend archives a customer with orders instead of deleting it; a main
 * company with branches is refused (the operator detaches the branches first).
 */
export async function deleteCustomerWithFeedback(
  customer: { id: string; name: string },
  t: TFunction,
  feedback: FeedbackApi
): Promise<CustomerDeleteOutcome> {
  try {
    const result = await deleteCustomer(customer.id);
    if (result.archived) {
      feedback.success(t('customers:customerArchived', { name: customer.name, count: result.orderCount }));
      return 'archived';
    }
    feedback.success(t('customers:customerDeleted', { name: customer.name }));
    return 'deleted';
  } catch (error: any) {
    if (BRANCHES_BLOCK_MESSAGES.includes(error?.response?.data?.message)) {
      // Blocked destructive operation — the operator must detach the branches first.
      feedback.error(t('customers:messages.deleteBlockedByBranches', { name: customer.name }), { sticky: true });
    } else {
      feedback.error(t('customers:messages.deleteError', { name: customer.name }));
    }
    return 'failed';
  }
}
